import {defineMessages} from 'react-intl'

/**
 *  define backToForm translation
 */
export const genericMessages = defineMessages({
  backToForm: {
    id: 'backToForm',
    defaultMessage: 'Back to form'
  }
})
/**
 *  define bookingErrorMessages translation
 */
export const bookingErrorMessages = defineMessages({
  brazilianTaxIdInvalidTitle: {
    id: 'errors.brazilianTaxIdInvalidTitle',
    defaultMessage: 'Incorrect CPF or CNPJ'
  },
  brazilianTaxIdInvalidDescription: {
    id: 'errors.brazilianTaxIdInvalidDescription',
    defaultMessage: 'Reenter your CPF or CNPJ and try again.'
  },
  requestErrorTitle: {
    id: 'requestErrorTitle',
    defaultMessage: 'Payment failed'
  },
  cardNotSupportedTitle: {
    id: 'errors.cardNotSupportedTitle',
    defaultMessage: 'Card not supported'
  },
  connectionErrorTitle: {
    id: 'errors.connectionErrorTitle',
    defaultMessage: 'Connection error'
  },
  connectionErrorDescription: {
    id: 'errors.connectionErrorDescriptionV3',
    defaultMessage:
      "Your booking confirmation is on its way. It may take a few minutes and could land in your spam folder.<br></br><br></br>If you don't get a confirmation, contact support. Don't attempt to make a new booking."
  },
  duplicateBookingTitle: {
    id: 'errors.duplicateBookingTitle',
    defaultMessage: 'Duplicate booking'
  },
  duplicateBookingDescription: {
    id: 'errors.duplicateBookingDescriptionV3',
    defaultMessage:
      "You made an identical booking a few seconds ago.<br></br><br></br>You can't make duplicate bookings. Check your inbox or spam for confirmation of the first booking."
  },
  genericErrorMessageTitle: {
    id: 'genericErrorTitle',
    defaultMessage: 'Booking failed'
  },
  genericErrorMessage: {
    id: 'errors.genericErrorDescriptionV3',
    defaultMessage: 'Try again, or try booking a different deal.'
  },
  cardNotSupportedDescription: {
    id: 'errors.cardNotSupportedDescriptionV2',
    defaultMessage: 'Choose another card and try again.'
  },
  incorrectCVCTitle: {
    id: 'errors.incorrectCVVTitle',
    defaultMessage: 'Incorrect CVV'
  },
  incorrectCVCDescription: {
    id: 'errors.incorrectCVCDescriptionV3',
    defaultMessage: "Reenter your card's security code and try again."
  },
  incorrectCCTitle: {
    id: 'errors.incorrectCCTitle',
    defaultMessage: 'Incorrect card number'
  },
  genericFraudDeclinedMessageV3: {
    id: 'errors.genericFraudDeclinedMessageV3',
    defaultMessage: 'Try a different payment method or contact your bank.'
  },
  genericFraudDeclinedMessageCardOnly: {
    id: 'errors.genericFraudDeclinedMessageCardOnly',
    defaultMessage: 'Try a different card or contact your bank.'
  },
  paymentDeclinedMessage: {
    id: 'errors.paymentDeclined',
    defaultMessage: 'Payment declined'
  },
  genericFraudDeclinedTitlePayLater: {
    id: 'errors.genericFraudDeclinedTitlePayLater',
    defaultMessage: 'Failed to add payment method'
  },
  invalidEmailTitle: {
    id: 'errors.invalidEmailTitle',
    defaultMessage: 'Invalid email'
  },
  invalidEmailDescriptionV3: {
    id: 'errors.invalidEmailDescriptionV3',
    defaultMessage: 'Reenter your email and try again.'
  },
  incorrectCCDescription: {
    id: 'errors.incorrectCCDescription',
    defaultMessage: 'Reenter your card number and try again'
  },
  insufficientFundsTitle: {
    id: 'errors.insufficientFundsTitle',
    defaultMessage: 'Insufficient funds'
  },
  soldOutDescription: {
    id: 'errors.soldoutDescription',
    defaultMessage:
      'We just sold out of your selected deal–check out these similar deals from our trusted partners:'
  },
  soldOutTitle: {
    id: 'errors.soldoutTitle',
    defaultMessage: 'Sold out on {brandName}'
  },
  genericCardErrorTitle: {
    id: 'errors.genericCardErrorTitle',
    defaultMessage: 'Incorrect card details'
  },
  genericCardErrorDescription: {
    id: 'errors.genericCardErrorDescription',
    defaultMessage:
      'Check your card details below and try again after fixing the incorrect field.'
  },
  contactSupportMessage: {
    id: 'errors.bookingErrorDescription',
    defaultMessage: 'Try again or if the problem persists, contact support'
  },
  tokenizationServiceUnavailableTitle: {
    id: 'errors.tokenizationServiceUnavailableTitle',
    defaultMessage: 'We couldn’t process your payment'
  },
  tokenizationServiceUnavailableDescription: {
    id: 'errors.tokenizationServiceUnavailableDescription',
    defaultMessage:
      '• Try again in a few minutes <br></br> • Pay with another method, such as Apple Pay or Google Pay (if available)'
  },
  unexpectedBookingErrorTitle: {
    id: 'errors.unexpectedBookingErrorTitle',
    defaultMessage: 'Something went wrong'
  },
  unexpectedBookingErrorNoBookingIdDescription: {
    id: 'errors.unexpectedBookingErrorNoBookingIdDescription',
    defaultMessage:
      'We couldn’t complete your booking just yet, but it’s likely still being processed. Please wait up to 15 minutes for a confirmation email before trying again'
  },
  unexpectedBookingErrorDescription: {
    id: 'errors.unexpectedBookingErrorDescription',
    defaultMessage:
      'We couldn’t complete your booking just yet, but it’s likely still being processed. You can check the booking status below.'
  },
  unexpectedBookingErrorCheckEmail: {
    id: 'errors.unexpectedBookingErrorCheckEmail',
    defaultMessage: 'If you receive an email, your booking was successful.'
  },
  unexpectedBookingErrorWaitForEmail: {
    id: 'errors.unexpectedBookingErrorWaitForEmail',
    defaultMessage:
      'If you’re unsure or don’t receive a confirmation email within 15 minutes, please contact support.'
  },
  bookingStatusCheckFailed: {
    id: 'errors.bookingStatusCheckFailed',
    defaultMessage: 'Booking status still unavailable'
  },
  bookingStatusCheckFailedDescription: {
    id: 'errors.bookingStatusCheckFailedDescription',
    defaultMessage:
      'We weren’t able to retrieve your booking status just yet. It may still be processing in the background.'
  },
  bookingStatusCheckFailedContactSupport: {
    id: 'errors.bookingStatusCheckFailedContactSupport',
    defaultMessage:
      'If you don’t receive a confirmation email within 15 minutes, please contact support.'
  },
  paymentDeclinedWithCTA: {
    id: 'errors.paymentDeclinedWithCTA',
    defaultMessage:
      'Try a different payment method, contact your bank or {brandName} support.'
  },
  paymentDeclinedWithCTACardOnly: {
    id: 'errors.paymentDeclinedWithCTACardOnly',
    defaultMessage:
      'Try a different card, contact your bank or {brandName} support.'
  },
  paymentLimitExceededDescription: {
    id: 'errors.paymentLimitExceededDescription',
    defaultMessage: 'Contact your bank and try again later.'
  },
  doubleBookingDescription: {
    id: 'errors.doubleBookingDescription',
    defaultMessage: 'It looks like you’ve already booked this stay.'
  },
  technicalIssueDescription: {
    id: 'errors.technicalIssueDescription',
    defaultMessage: 'Try a different payment method or try again later.'
  },
  technicalIssueDescriptionCardOnly: {
    id: 'errors.technicalIssueDescriptionCardOnly',
    defaultMessage: 'Try a different card or try again later.'
  },
  idealRefundIssuedTitle: {
    id: 'errors.idealRefundIssuedTitle',
    defaultMessage:
      'Your selected deal sold out while your payment was processing'
  },
  idealRefundIssuedDescription: {
    id: 'errors.idealRefundIssuedDescription',
    defaultMessage:
      'Any payment taken will be refunded within 2–3 working days.'
  }
})
